import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

const BlogIconOptions = [
    { label: '16x16', value: '16' },
    { label: '32x32', value: '32' },
    { label: '64x64', value: '64' },
]

class AdamForm extends Component {
    @autobind
    handleChangeIcoSize(item) {
        const { onChange } = this.props
        onChange(
            Object.assign({},  this.props.data, {
                setting: Object.assign({},  this.props.data.setting, {
                    ico_size: item.value
                }),
                validated: true
            })
        )
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin28">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_plugin">
                    <div className="item_set item_sub">
                        아이콘은
                        <TSelectForm className="opt_set opt_plugin1" items={BlogIconOptions} selected={data.setting.ico_size} onSelect={this.handleChangeIcoSize}/>
                        px 크기로 표시합니다.
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

AdamForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default AdamForm
